import { IMAGES } from '@aca-new/app/shared/constants/images.constants';
import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-empty-content',
  templateUrl: './empty-content.component.html',
  styleUrls: ['./empty-content.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, NgIf],
})
export class EmptyContentComponent {
  /**
   * @description
   * Image
   * @type {string}
   * @default IMAGES.emptyContentTable
   */
  @Input('emptyContentImage')
  public image: string = IMAGES.emptyContentTable;

  /**
   * @description
   * Message
   * @type {string}
   * @default ''
   */
  @Input('emptyContentMessage')
  public message: string = '';
}
